import { Component, OnInit, ViewChild, ChangeDetectorRef , NgZone} from '@angular/core';
import { CustomerService } from '../../customer/services/customer.service';
import { PaymentPlanDefaults } from '../model/payment-plan';
import { FormGroupDirective, Validators } from '@angular/forms';
import { OperationService } from '../service/operation.service';
import { ConfirmationDialogService } from 'src/app/common/component/confirmation-dialog/confirmation-dialog.service';
import { PaymentHubService } from '../service/payment-hub.service';
import { PaymentHubComponent } from '../payment-hub.component';
declare var CollectJS: any;

@Component({
  selector: 'wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['../payment-hub.component.css', './wallet.component.css'],
})
export class WalletComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  @ViewChild('documentEditForm') documentEditForm: FormGroupDirective;

    LABEL_ACCOUNT_NUMBER: string;
    LABEL_INVOICE_NUMBER: string;
    LABEL_ACCOUNT_NAME: string;
    LABEL_CUSTOMER: string;
    LABEL_INVOICE_DATE: string;
    brands: any;

  isCardShow = false;
  isBankInfoShow = false;
  isKeypadShow = false;
  isSavedCardShow = false;
  isEditWalletShow = false;

  username: string;
  transactionId: string;

  formUrl: string;
  billingId: string;
  cards: any;
  wallet: any;
  isEditing: boolean;
  isDisabled: boolean;

  isNicknameSelected: boolean;

  onSubmitLoader: boolean;
  cardErr: any;
  collectJSFields: any;
  response: any;
  refreshIntervalId: any;

  accounts: any[];

  achBusinessAccount: any;
  keypadDataLocked: boolean;

  months: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  years: string[] = [];
  expirationMonth: string;
  expirationYear: string;

    constructor(private operationService: OperationService, private ref: ChangeDetectorRef, private customerService: CustomerService, private confirmationDialogService: ConfirmationDialogService, private paymentHubService: PaymentHubService, public paymentHubComponent: PaymentHubComponent, private ngZone: NgZone) {
    this.isCardShow = false;
    this.isBankInfoShow = false;
    this.isSavedCardShow = false;
    this.isEditing = false;
    this.formUrl = '';
    this.billingId = '';
    this.cards = undefined;

    this.username = '';
    this.transactionId = '';
    this.refreshIntervalId = '';
    this.response = {};
    this.isDisabled = false;
    this.isNicknameSelected = false;
    this.onSubmitLoader = false; this.cardErr = {
        checkname: {
            flag: false,
            msg: ''
        },
        ccnumber: {
            flag: false,
            msg: ''
        },
        ccexp: {
            flag: false,
            msg: ''
        },
        cvv: {
            flag: false,
            msg: ''
        },
        checkaba: {
            flag: false,
            msg: ''
        },
        checkaccount: {
            flag: false,
            msg: ''
        },
    };
    this.achBusinessAccount = false;
    this.keypadDataLocked = false;

    // populate years[] for card update ccexp dropdown
    this.expirationMonth = '';
    this.expirationYear = '';
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 20; i++) {
      this.years.push((currentYear + i).toString());
    }
    
    }

  ngOnInit(): void {
    this.username = localStorage.getItem(PaymentPlanDefaults.CONSTANT_USERNAME);
    this.transactionId = localStorage.getItem(PaymentPlanDefaults.CONSTANT_TRANSACTION_ID);
    this.loadBranding();
    this.loadWallets();
    this.loadAccounts();
  }

    getWalletAccountNumbers(card){
      return card.customerAccounts.map(customerAccount => customerAccount.accountNumber);
    }

    loadBranding() {
        this.paymentHubService.branding().subscribe(res => {
            if (res.status !== 200) {
                alert(res.body);
                return;
            }
            this.brands = res.body;
            if (this.brands) {
                this.LABEL_ACCOUNT_NUMBER = this.getText('2', 'Account Number');
                this.LABEL_INVOICE_DATE = this.getText('4', 'Invoice Date');
                this.LABEL_INVOICE_NUMBER = this.getText('3', 'Invoice Number');
                this.LABEL_ACCOUNT_NAME = this.getText('1', 'Name');
                this.LABEL_CUSTOMER = this.getText('5', 'Customer');
            }
        }, err => {
            console.log(err);
            alert(err.error.message);
        });
    }

    getText(label: string, defaultValue: string): string {
        const val = this.brands.find(x => x.dbId == label);
        return val == null || false ? defaultValue : val.text;
    }
  // ==========================================================================================

  toggleCardShow(type: any) {
    this.isCardShow = type;
    this.isBankInfoShow = false;
    this.isKeypadShow = false;
    this.isSavedCardShow = false;

    if (!this.isCardShow) {
      this.isEditing = false;
      this.isDisabled = false;
    }

    if (this.isCardShow && !this.isDisabled) {
        this.wallet = {
            sid: null,
            name: '',
            nickname: '',
            zipCode: '',
            tokenId: null,
            tokenType: null,
            card: null,
            checkAccount: null
        };
    }

    if (this.isCardShow) {
        this.loadCollectJS();
    }
  }


  toggleBankInfoShow(type: any) { 
    this.isBankInfoShow = type;
    this.isCardShow = false;
    this.isKeypadShow = false;
    this.isSavedCardShow = false;

    if (!this.isBankInfoShow) {
      this.isEditing = false;
      this.isDisabled = false;
    }

    if (this.isBankInfoShow && !this.isDisabled) {
        this.wallet = {
            sid: null,
            name: '',
            nickname: '',
            zipCode: '',
            tokenId: null,
            tokenType: null,
            card: null,
            checkAccount: null
        };

    }

    if (this.isBankInfoShow) {
        this.loadCollectJS();
    }
  }


  toggleKeypadShow(type: any) {
    this.isKeypadShow = type;
    this.isCardShow = false;
    this.isBankInfoShow = false;
    this.isSavedCardShow = false;
    this.keypadDataLocked = false;

    if (!this.isKeypadShow) {
        this.isEditing = false;
        this.isDisabled = false;
    }

    if (this.isKeypadShow && !this.isDisabled) {
        this.wallet = {
            sid: null,
            name: '',
            nickname: '',
            zipCode: '',
            tokenId: null,
            tokenType: null,
            card: null,
            checkAccount: null
        };
    }
  }

  // ======= Update Wallet Related Functions ================================================

  toggleEditWalletShow(card: any) {
    this.isEditWalletShow = !this.isEditWalletShow;
    this.isKeypadShow = false;
    this.isCardShow = false;
    this.isBankInfoShow = false;
    this.isSavedCardShow = false;
    this.keypadDataLocked = false;

    if (!this.isEditWalletShow) {
      this.isEditing = false;
      this.isDisabled = false;
    }

    if (this.isEditWalletShow && !this.isDisabled) {
        this.wallet = { ...card };  // create a shallow copy  since we don't need nested objects
        if(this.wallet.ccNumber != undefined) {
            // check for 924 and make it format to > 09 instead of '9'
          this.expirationMonth = this.wallet.ccExp.length == 3 ? ('0' + this.wallet.ccExp.substring(0, 1) ) : this.wallet.ccExp.substring(0, 2);
          this.expirationYear = '20' + this.wallet.ccExp.substring(this.wallet.ccExp.length == 3 ? 1 : 2) // the year is 20XX, if year >= 2100, pls update
        }
    }
  }

  onEditWalletSubmit() {
    if(this.wallet.ccNumber != undefined && (this.expirationMonth != '' && this.expirationYear != '') ) {
          if (!this.isDateValid()) {
                    alert('Expiration date is invalid!');
                    return;
          } else {
            this.wallet.ccExp = this.expirationMonth + this.expirationYear.substring(2);
        }
    } else {
        this.wallet.ccExp = '';
    }

    this.updateWalletCard(this.wallet);
    this.isEditWalletShow = !this.isEditWalletShow;
  }

  onEditWalletCancel() {
    this.isEditWalletShow = !this.isEditWalletShow;
    this.wallet = {};
  }

  isDateValid(): boolean {
    // only debit&credits have exp dates
    if(this.wallet.ccNumber != undefined ) {
      const submittedCcExp = this.expirationMonth + this.expirationYear;
      const ccExpMonth = parseInt(submittedCcExp.substring(0,2),10);
      const ccExpYear = parseInt(submittedCcExp.substring(2,6), 10);
      const nextMonth = new Date().getMonth() + 2; 
      const currentYear = new Date().getFullYear();

    if (ccExpYear > currentYear) {
              return true;
    } else if (ccExpYear === currentYear) {
              return ccExpMonth >= nextMonth;
    } else {
          return false;
      }
    } else {
      return true;
    }
  }


  // ==========================================================================================

  private loadWallets(): any {
    this.wallet = {};
    this.ngZone.run(() => { 
    this.operationService.wallets(this.transactionId).subscribe(res => {
      if (res.status !== 200) {
        alert(res.body);
        return;
      }
      this.cards = res.body;
      this.ref.detectChanges();
    }, err => {
      console.log(err);
      alert(err.error.message);
    });
  });
  }

  onDelete(card: any) {
    this.confirmationDialogService.confirm(ConfirmationDialogService.getWalletDeleteMessage(card.nickname, this.getWalletAccountNumbers(card)))
      .then((confirmed) => {
        if (!confirmed) {
          return;
        }
        this.operationService.deleteWallet(this.transactionId, card.sid).subscribe(res => {
          if (res.status !== 200) {
            alert(res.body);
            return;
          }
          this.cards = this.cards.filter(item => item !== card);
        }, err => {
          console.log(err);
          alert(err.error.message);
        });
      }
      ).catch(() => { });
  }

 updateWalletCard(card: any) {
      this.confirmationDialogService.confirm(ConfirmationDialogService.getWalletEditMessage(card.nickname, this.getWalletAccountNumbers(card)))
      .then((confirmed) => {
        if (!confirmed) {
          return;
            }
        // only cards that already exist can be updated
        if (!card.sid) {
          return;
        }
        console.log('Request Card Update:' + card.sid)

        // add more to editCardRequest if needed
        const cardEditRequest = {
          walletId: card.sid,
          nickname: (card.nickname == null ? '' : card.nickname),
          ccExp: (card.ccExp == null ? '' : card.ccExp)
        };

        this.ngZone.run(() => {
        this.operationService.walletEdit(this.transactionId, JSON.stringify(cardEditRequest)).subscribe(res => {
          if (res.status !== 200) {
            alert(res.body);
          }
          this.loadWallets();

        }, err => {
          console.log(err);
          alert(err.error.message);
        });
    
        });
    });
  }

  private loadAccounts(): void {
    this.customerService.accounts(this.transactionId).subscribe(res => {
      if (res.status !== 200) {
        alert(res.body);
        return;
      }
      this.accounts = res.body;
    }, err => {
      console.log(err);
      alert(err.error.message);
    });
    }

  public displayLoadingImage(){
    this.onSubmitLoader = true;
  }

  public disableLoadingImage(){
    this.onSubmitLoader = false;
    this.ref.detectChanges();
  }

    public loadCollectJS() {
        this.ref.detectChanges();

        this.collectJSFields = {
            checkname: {
                placeholder: this.isCardShow ? 'Name on Card' : 'Name on Account',
                selector: '#ccName'
            },
            ccnumber: {
                placeholder: '0000 0000 0000 0000',
                selector: '#ccNumber'
            },
            ccexp: {
                placeholder: '00/00',
                selector: '#ccExp'
            },
            cvv: {
                display: 'hide',
                placeholder: '000 or 0000',
                selector: '#cvv'
            },
            checkaba: {
                placeholder: 'Routing Number',
                selector: '#routingNo'
            },
            checkaccount: {
                placeholder: 'Account Number',
                selector: '#acNumber'
            }

        };

        CollectJS.configure({
            paymentSelector: '#collectJsSubmissionTrigger',
            variant: 'inline',
            styleSniffer: true,
            validationCallback: (field: string | number, status: any, message: any) => {
                if (status) {
                    this.cardErr[field] = {
                        flag: false,
                        msg: ''
                    };
                } else {
                    this.cardErr[field] = {
                        flag: true,
                        msg: message
                    };
                }
                console.log(this.cardErr);
                this.ref.detectChanges();
            },
            timeoutDuration: 10000,
            timeoutCallback: () => {
              this.disableLoadingImage();
              console.log('The tokenization didn\'t respond in the expected timeframe.  This could be due to an invalid or incomplete field or poor connectivity');
            },
            fieldsAvailableCallback: () => {
                console.log('Collect.js loaded the fields onto the form');
            },
            callback: (response: any) => {
                console.log(response);
                this.handleNmiResponseAndContinue(response);
            },
            fields: this.collectJSFields
        });

        this.startCollectJsWalletRequest();
        this.ref.detectChanges();
    }

    startCollectJsWalletRequest() {
        CollectJS.startPaymentRequest();
    }

    handleNmiResponseAndContinue(response: any) {
        let card = null;
        let checkAccount = null;

        if (this.isCardShow) {
            card = {
                cardNumber: response.card.number,
                expDate: response.card.exp
            };
        } else if (this.isBankInfoShow) {
            checkAccount = {
                routingNumber: response.check.aba,
                accountNumber: response.check.account,
                businessAccount: this.achBusinessAccount
            };
        }

        this.wallet.sid = this.isEditing ? this.wallet.sid : null;
        this.wallet.name = response.check.name;
        this.wallet.tokenId = response.token;
        this.wallet.tokenType = 'COLLECT_JS';
        this.wallet.card = card;
        this.wallet.checkAccount = checkAccount;

        this.addWallet();
    }

    handleKeypadSubmission() {
        this.wallet.sid = this.isEditing ? this.wallet.sid : null;

        // THIS WILL NEED TO BE MADE A SWITCH IN THE FUTURE
        if (this.paymentHubComponent.keypadType === 'M100') {
            this.wallet.tokenType = 'KEYPAD_M100_M130_KEYED_DATA';
        }

        // THIS.WALLET.CARD IS CREATED AND VALUES NULL BECAUSE WALLET TYPE DETERMINATION IS BRILLIANTLY BASED ON CARD OR
        // CHECKACCOUNT BEING NULL OR NOT AND WITH KEYPADS WE RECEIVE NO CARD DATA IN THE RESPONSE, UNLIKE COLLECT.JS

        this.wallet.card = {
            cardNumber: null,
            expDate: null
        };

        this.addWallet();
    }

    private addWallet() {
        this.operationService.addWallet(this.transactionId, this.wallet).subscribe(
            res => {
                if (res.status !== 200) {
                    alert(res.body);
                    this.onSubmitLoader = false;
                }
                this.toggleCardShow(false);
                this.disableLoadingImage();
                this.loadWallets();
            }, err => {
                console.log(err);
                alert(err.error.message);
                this.onSubmitLoader = false;
            }
        );
    }

    // KEYPAD FUNCTIONALITY

    lockKeypadDataFieldIfInputValid() {
        // THIS WILL NEED TO BE MADE A SWITCH IN THE FUTURE
        if (this.paymentHubComponent.keypadType === 'M100') {
            if (this.wallet.tokenId.length === 160) {
                this.keypadDataLocked = true;
                this.ref.detectChanges();
            }
        }
    }
}
